import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { CpForecastService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-body/control-page-forecast/cp-forecast-service';
import * as moment from 'moment';

@Component({
  selector: 'app-cp-forecast-tab-week',
  templateUrl: './cp-forecast-tab-week.component.html',
  styleUrl: './cp-forecast-tab-week.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CpForecastTabWeekComponent {

  forecast = inject(CpForecastService).forecast;

  EnumMeasureTypes = EnumMeasureTypes;

  getDay(time: number): string {
    return moment(time * 1000).format('dddd');
  }

}
